var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_463_588)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7281 6.11394C27.7861 4.88728 26.1114 3.48861 26.1114 3.48861C24.1881 1.97594 21.8608 0.87861 19.2268 0.343277C14.7961 -0.55539 10.5308 0.349277 7.15011 2.59128C3.75877 4.82194 1.25277 8.39994 0.346774 12.8566C-0.643892 17.7319 0.538774 22.3839 3.27211 25.8839C3.27211 25.8839 3.51944 26.2273 4.01011 26.7579L4.01344 26.7553C5.91677 24.8653 6.57344 22.0773 5.78677 19.5146C5.24077 17.7386 5.13411 15.7913 5.53077 13.8433C6.16011 10.7466 7.95477 8.14994 10.4174 6.57528C12.5894 5.20461 15.2761 4.63061 18.1474 5.21394C24.3121 6.46394 27.6581 12.3006 26.4674 18.1566C25.8388 21.2533 24.0441 23.8486 21.5808 25.4246C19.4081 26.7953 16.7214 27.3693 13.8514 26.7873C13.3108 26.678 12.7789 26.5291 12.2601 26.3419C9.80077 25.4539 7.04811 26.0786 5.19344 27.9199C5.40811 28.1113 5.63877 28.3093 5.88811 28.5113C7.81077 30.0239 10.1388 31.1213 12.7728 31.6559C17.2028 32.5553 21.4688 31.6506 24.8494 29.4086C28.2401 27.1793 30.7474 23.6006 31.6534 19.1433C32.6441 14.2679 31.4621 9.61594 28.7281 6.11594V6.11394ZM5.88877 28.5099L5.95544 28.4439L5.96077 28.4486C5.93677 28.4699 5.91277 28.4893 5.88877 28.5099Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_463_588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOx);
export default __webpack_public_path__ + "static/media/OX.be7a2820d5437f3683558a5bf65ef5d1.svg";
export { ForwardRef as ReactComponent };